module.exports = __webpack_public_path__ + "img/containers.5608e888.png";